/* eslint-disable import/max-dependencies */
import { Container, Box } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import { bindActionCreators } from "redux";
import { Loader, LoadingButton } from "@fas/ui-core";
import { useNavigate } from "react-router";
import { getErrors } from "@fas/ui-framework";
import { Settings as SettingsForm } from "../../../components/LinkingInfoForm";
import type {
  Algorithm as LinkingInfoAlgorithm,
} from "../../../components/LinkingInfoForm/types/LinkingInfoForm.types";
import {
  getSorting,
  getHeight,
  getWidth,
  getAlgorithm,
  getType as getLinkingType,
  getTagsGeneration,
} from "../../../selectors/linking";
import {
  setLinkingInfoSorting,
  setLinkingInfoWidth,
  setLinkingInfoAlgorithm,
  getLinkingInfoHeightSaga,
  saveLinkingInfoSaga,
} from "../../../actions/linkingList";
import {
  getIsLinkedItemSavingLoading,
  getIsLinkedItemLoading,
  getIsLinkedItemHeightLoading,
} from "../../../selectors/loading";
import {
  getLinkingSortings,
  getLinkingAlgorithms,
} from "../../../selectors/accountModules";
import type { State } from "../../../pages/AppStoreWrapper";
import type { StateToProps, DispatchToProps, Props } from "./types/Settings.type";

const mapStateToProps: (state: State) => StateToProps = (state) => ({
  type: getLinkingType(state),
  sorting: getSorting(state),
  width: getWidth(state),
  height: getHeight(state),
  errors: getErrors(state),
  algorithm: getAlgorithm(state),
  tagsGeneration: getTagsGeneration(state),
  isHeightLoading: getIsLinkedItemHeightLoading(state),
  linkingSortings: getLinkingSortings(state),
  linkingAlgorithms: getLinkingAlgorithms(state),
  linkedInfoLoading: getIsLinkedItemLoading(state),
  saveLoading: getIsLinkedItemSavingLoading(state),
});

const mapDispatchToProps: (arg0: Dispatch<any>) => DispatchToProps = dispatch => ({
  ...bindActionCreators({
    onWidthChange: setLinkingInfoWidth,
    onSortingChange: setLinkingInfoSorting,
    onAlgorithmChange: setLinkingInfoAlgorithm,
    getLinkingInfoHeight: getLinkingInfoHeightSaga,
    onSave: saveLinkingInfoSaga,
  }, dispatch),
});
function Settings({
  sorting,
  width,
  height,
  onWidthChange,
  onSortingChange,
  errors,
  linkedInfoLoading,
  onAlgorithmChange,
  algorithm,
  type,
  tagsGeneration,
  getLinkingInfoHeight,
  isHeightLoading,
  linkingSortings,
  linkingAlgorithms,
  saveLoading,
  onSave,
}: Props) {
  useEffect(() => {
    getLinkingInfoHeight(tagsGeneration);
  }, [getLinkingInfoHeight, tagsGeneration]);

  const navigate = useNavigate();
  return (
    <Container>
      <Loader loading={linkedInfoLoading}>
        <SettingsForm
          type={type}
          sorting={sorting}
          width={width}
          height={height}
          onWidthChange={onWidthChange}
          onSortingChange={onSortingChange}
          onAlgorithmChange={(val: string) => onAlgorithmChange(val as LinkingInfoAlgorithm)}
          algorithm={algorithm}
          algorithms={linkingAlgorithms}
          isHeightLoading={isHeightLoading}
          errors={errors.toJS()}
          sortings={linkingSortings}
        />
        <Box mt={3} display="flex" justifyContent="flex-end">
          <LoadingButton
            sx={{
              ml: 1,
            }}
            type="button"
            size="medium"
            variant="contained"
            color="primary"
            loading={saveLoading}
            onClick={() => onSave(navigate)}
            data-testid="next-button"
          >
            Save
          </LoadingButton>
        </Box>
      </Loader>
    </Container>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings as any);
